//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'VyEditBtn',
  components: {
  },
  props: {
    text: {
      type: String,
      default: '编辑',
    },
  },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/components/crm-ui/VyEditBtn.vue